var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommL(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.375 16.875C33.9554 16.875 37.3892 18.2973 39.9209 20.8291C42.4527 23.3608 43.875 26.7946 43.875 30.375C43.875 33.9554 42.4527 37.3892 39.9209 39.9209C37.3892 42.4527 33.9554 43.875 30.375 43.875C26.7946 43.875 23.3608 42.4527 20.8291 39.9209C18.2973 37.3892 16.875 33.9554 16.875 30.375C16.875 26.7946 18.2973 23.3608 20.8291 20.8291C23.3608 18.2973 26.7946 16.875 30.375 16.875ZM30.375 50.625C39.3862 50.625 57.375 55.1475 57.375 64.125V70.875H3.375V64.125C3.375 55.1475 21.3638 50.625 30.375 50.625ZM56.565 18.09C63.3825 25.515 63.3825 35.8088 56.565 42.6263L50.895 36.9225C53.73 32.94 53.73 27.7763 50.895 23.7938L56.565 18.09ZM67.7363 6.75C81 20.4188 80.8988 40.8713 67.7363 54L62.235 48.4987C71.5838 37.7662 71.5838 22.4438 62.235 12.2513L67.7363 6.75Z",
    fill: "#C08552"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommL);
export default __webpack_public_path__ + "static/media/commL.8c92284277ff6c44e5fa89a3a8bb8c30.svg";
export { ForwardRef as ReactComponent };